module.exports = require("npm:delegated-events@1.0.5/dist/index.umd.js");